import config from 'helpers/config';
import utils from 'helpers/utils';
import { getToken } from 'http/clientToken';

const request = (method, url, data) => {
    const options = {
        credentials: 'include',
        method: method,
        headers: {
            Accept: 'application/json',
        },
    };

    const token = getToken();

    if (token) {
        options.headers['Client-Application-Token'] = token;
    }

    if (data) {
        options.body = JSON.stringify(data);
        options.headers['Content-Type'] = 'application/json';
    }

    return new Promise((resolve, reject) => {
        fetch(config.getApiBaseUrl() + url, options).then((response) => {
            if (response.status === 204) {
                return resolve();
            }

            response.json().then((responseJson) => {
                if (response.ok) {
                    resolve(responseJson);
                } else {
                    reject(responseJson);
                }
            });
        }).catch((e) => {
            reject({
                code: 0,
                message: e.message,
            });
        });
    });
};

export default {
    delete: (url) => {
        return request('DELETE', url);
    },
    get: (url, query) => {
        return request('GET', utils.buildUrl(url, query));
    },
    patch: (url, data) => {
        return request('PATCH', url, data);
    },
    post: (url, data) => {
        return request('POST', url, data);
    },
};



// WEBPACK FOOTER //
// ./src/http/client.js